
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/routes/[id]",
      function () {
        return require("private-next-pages/routes/[id]/index.tsx");
      }
    ]);
  